function DotIcon() {
  return (
    <svg height="16" width="16">
      <circle cx="8" cy="10" r="1" stroke="black" strokeWidth="3" />
    </svg>
  )
}

export default DotIcon
